var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.99992C13.1585 1.99992 15.9752 3.77492 17.3502 6.58325C15.9752 9.39159 13.1585 11.1666 10.0002 11.1666C6.84183 11.1666 4.02516 9.39159 2.65016 6.58325C4.02516 3.77492 6.84183 1.99992 10.0002 1.99992ZM10.0002 0.333252C5.8335 0.333252 2.27516 2.92492 0.833496 6.58325C2.27516 10.2416 5.8335 12.8333 10.0002 12.8333C14.1668 12.8333 17.7252 10.2416 19.1668 6.58325C17.7252 2.92492 14.1668 0.333252 10.0002 0.333252ZM10.0002 4.49992C11.1502 4.49992 12.0835 5.43325 12.0835 6.58325C12.0835 7.73325 11.1502 8.66658 10.0002 8.66658C8.85016 8.66658 7.91683 7.73325 7.91683 6.58325C7.91683 5.43325 8.85016 4.49992 10.0002 4.49992ZM10.0002 2.83325C7.9335 2.83325 6.25016 4.51659 6.25016 6.58325C6.25016 8.64992 7.9335 10.3333 10.0002 10.3333C12.0668 10.3333 13.7502 8.64992 13.7502 6.58325C13.7502 4.51659 12.0668 2.83325 10.0002 2.83325Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.bceb383116220e163acfd7f2b4806fab.svg";
export { ForwardRef as ReactComponent };